<om-label *ngIf="label" [text]="label" [icon]="icon" [isRequired]="isRequired$ | async"></om-label>
<nz-date-picker
  class="w-full"
  [nzShowTime]="showTime"
  [formControl]="_control"
  [nzPlaceHolder]="placeholder"
  [nzDisabledDate]="_disabledDate"
  [nzDisabled]="disabled"
  [nzAllowClear]="allowClear"
  [nzFormat]="dateFormat"
  (nzOnOpenChange)="onOpenChange($event)"
>
</nz-date-picker>
<div class="om-error-placeholder">
  <om-error [control]="control"></om-error>
</div>
